// ----------------------------------------------------------------------------
// Snippet: Product-form
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

$(function() {
    //Navigate Tabs
    $('.product-size-nav button').on('keydown', function(e) {
        var tabButton = $(e.target);
        var prevTab = $(e.target).prev();
        var nextTab = $(e.target).next();
        
        if (e.type === 'keydown') {
            let key = e.key;
            if (key === "Tab") {
                return;
            } else {
                switch(key) {
                    case "Enter":
                        tabButton.siblings().attr("tabindex", -1);
                        tabButton.attr("tabindex", 0);
                        break;
                    case " ":
                        e.preventDefault();
                        tabButton.trigger("click");
                        tabButton.siblings().attr("tabindex", -1);
                        tabButton.attr("tabindex", 0);
                        break;
                    case 'ArrowRight':  // right
                        // Moves focus to the next item in the tablist.
                        e.preventDefault();
                        // If focus is on the last item, moves focus to the first item.
                        if (nextTab.length <= 0) {
                            tabButton.siblings().first().trigger("focus");
                        } else {
                            nextTab.trigger("focus");
                        }
                        break;
                    case 'ArrowLeft': // left
                        // Moves focus to the previous item in the tablist.
                        e.preventDefault();
                        // If focus is on the first item, moves focus to the last item.
                        if (prevTab.length <= 0) {
                            tabButton.siblings().last().trigger("focus");
                        } else {
                            prevTab.trigger("focus");
                        }
                        break;
                }
            }
        }
    });
    
    //Add Aria Label to Active Tab on Load
    $('.swatch-toggle').each(function() {
        if($(this).hasClass('swatch-toggle--active')) {
            const swatchType = $(this).attr('data-type');
            $('.form__option-label--'+swatchType).closest('.form__field').attr('id','tab-panel-'+swatchType);
            $('.form__option-label--'+swatchType).closest('.form__field').attr('aria-labelledby','tab-'+swatchType);
        }
    });
});
